import { useEffect, useLayoutEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useLoadingStore, LoadingStatus } from '@/features/loading/stores/useLoadingStore';
import { REACT_QUERY_KEY_TO_RESOURCE } from '@/data/resources';

/**
 * Syncs React Query cache status with the loading store
 * Call this hook once in your app's loading provider
 */
export function useReactQueryLoader() {
  const queryClient = useQueryClient();
  const setStatus = useLoadingStore((s) => s.setStatus);

  useLayoutEffect(() => {
    //debugger
    const unsubscribe = queryClient.getQueryCache().subscribe((event) => {
      if (event.type !== 'updated' || !event.query) return; // if the type is not updated or its not a query ignore it

      // Extract query name from queryKey (first element if array, or the key itself)
      const queryKey = event.query.queryKey;
      const queryName = Array.isArray(queryKey) ? queryKey[0] : queryKey;

      // Map React Query queryKey to resource key
      const resourceKey = REACT_QUERY_KEY_TO_RESOURCE[queryName as keyof typeof REACT_QUERY_KEY_TO_RESOURCE];
      if (!resourceKey) return;

      const state = event.query.state;
      let status: LoadingStatus;

      if (state.status === 'pending') status = LoadingStatus.LOADING;
      else if (state.status === 'success') status = LoadingStatus.LOADED;
      else if (state.status === 'error') status = LoadingStatus.ERROR;
      else status = LoadingStatus.IDLE;

      setStatus(resourceKey, status, state.error?.message);
    });

    return () => unsubscribe();
  }, [setStatus, queryClient]);
}
